import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { history } from '../../../../../history'
import NormalLayoutContainer from '../../../../shared/NormalLayoutContainer'
import { PageTitle } from '../../../../../components/page-title'
import Error from '../../../../shared/Error'
import { Spinner } from '../../../../shared/Spinner'
import FormExplanation from '../../../../shared/FormExplanation'
import CurrentTicketRescheduleForm from './components/CurrentTicketRescheduleForm'
import QUERY_KEYS from '../../../../../graphql/queryKeys'
import dispatchTicket from '../../../../../graphql/queries/dispatchTicket'
import useMutation from '../../../../../hooks/useMutation'
import rescheduleTicket from '../../../../../graphql/mutations/rescheduleTicket'
import notify from '../../../../../utilities/notify'
import { RECEIVE_CURRENT_TICKET_FAILURE, RECEIVE_CURRENT_TICKET_SUCCESS } from '../../reducers/currentTicketReducer'
import handleError from '../../../../../utilities/handleError'

function HaulerTicketsReschedulePage ({ match }) {
  const { dataLoaders, form, currentTicket } = useSelector(({ dataLoaders, form, currentTicket }) => ({
    dataLoaders,
    form: form.currentTicketRescheduleForm,
    currentTicket
  }))

  const dispatch = useDispatch()

  const { errors } = currentTicket

  const [isFetching, setIsFetching] = useState(false)

  const fetchTicket = useCallback((id) => {
    if (!dataLoaders) return
    setIsFetching(true)
    const queryKey = [QUERY_KEYS.dispatchTicket, { ticketId: id }]
    dispatchTicket({ dataLoaders, queryKey })
      .then((fetchedTicket) => {
        dispatch({ type: RECEIVE_CURRENT_TICKET_SUCCESS, payload: fetchedTicket })
      })
      .catch((error) => {
        const errors = handleError(error)
        dispatch({ type: RECEIVE_CURRENT_TICKET_FAILURE, payload: { errors } })
      })
      .finally(() => {
        setIsFetching(false)
      })
  }, [dataLoaders, dispatch])

  const { mutate: rescheduleTicketMutation } = useMutation(rescheduleTicket, {
    onSuccess (data) {
      notify('success', 'Ticket Rescheduled Successfully')
      history.goBack()
    },
    onError () {
      notify('error', 'Error Rescheduling Ticket')
    }
  })
  const cancelRescheduleTicket = () => {
    history.goBack()
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    const { values } = form
    values.id = match.params.id
    rescheduleCurrentTicket(match.params.id, values)
  }

  const rescheduleCurrentTicket = (id, params) => {
    rescheduleTicketMutation({
      ticketId: id,
      date: params.date
    })
  }

  useEffect(() => {
    fetchTicket(match?.params?.id)
  }, [match?.params?.id, fetchTicket])

  return (
    <div>
      <NormalLayoutContainer showBackLink>
        <div className='container-fluid'>
          <PageTitle title='Reschedule a Company Ticket'>
            <button
              className='btn btn-lg btn-link pull-right push-down-very-small'
              onClick={cancelRescheduleTicket}>Cancel
            </button>
          </PageTitle>

          <Spinner isFetching={isFetching}>

            <div className='row'>
              <div className='col-xs-12 col-sm-12 col-md-7 col-lg-7'>

                <CurrentTicketRescheduleForm
                  isFetching={isFetching}
                  onSubmit={handleFormSubmit}
                />

              </div>
              <div className='col-xs-12 col-sm-12 col-md-4 col-md-offset-1 col-lg-4 col-lg-offset-1'>
                <div className='row'>
                  <FormExplanation
                    messages={[
                      'Please reschedule this ticket for your desired completion date.',
                      'This change will take place at the ticket level as well as the dispatch level.'
                    ]}
                  />
                </div>
              </div>
            </div>
          </Spinner>
        </div>
      </NormalLayoutContainer>
      <Error errors={errors} clearErrors={() => { }} />
    </div>
  )
}

HaulerTicketsReschedulePage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }).isRequired
  }).isRequired
}

export default HaulerTicketsReschedulePage
